import * as React from "react";
import type { SVGProps } from "react";
const SvgCurrencyRupee = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17.5 5h-11 3a4 4 0 1 1 0 8h-3l6 6m-6-10h11"
    />
  </svg>
);
export default SvgCurrencyRupee;
